import { render, staticRenderFns } from "./ProductAlert.vue?vue&type=template&id=386d6b76&"
import script from "./ProductAlert.vue?vue&type=script&lang=js&"
export * from "./ProductAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports